import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseTypes = {
  OTHER: 0,
  MEALS: 1,
  MILEAGE: 2,
  LABOUR: 3,
  AIRFARE: 4,
  LODGING: 5,
} as const

export type ExpenseTypeEnum = Enum<typeof ExpenseTypes>

export const EXPENSE_TYPE_NAME_BY_ENUM: Record<
  ExpenseTypeEnum,
  keyof typeof ExpenseTypes
> = {
  [ExpenseTypes.OTHER]: 'OTHER',
  [ExpenseTypes.MEALS]: 'MEALS',
  [ExpenseTypes.MILEAGE]: 'MILEAGE',
  [ExpenseTypes.LABOUR]: 'LABOUR',
  [ExpenseTypes.AIRFARE]: 'AIRFARE',
  [ExpenseTypes.LODGING]: 'LODGING',
}
